import Breadcrumb from "../about/Breadcrumb";
import SmallBanner from "../about/SmallBanner";

const Banner = () => {
  return (
    <SmallBanner title="Pricing Plan">
      {/* Breadcrumb */}
      <Breadcrumb
        breadcrumbs={[
          ["Home", "/"],
          ["Pricing Plan", "/"],
        ]}
      />
    </SmallBanner>
  );
};

export default Banner;
